import styled from "styled-components";
import SVG from "react-inlinesvg";

export const SecurityContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 20px;

    @media (min-width: 720px) {
        justify-content: center;
    }

    @media (min-width: 1100px) {
        padding: 10px 120px;
        justify-content: space-between;
    }

    p {
        color: #333;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    } 

    p.subtitle {
        text-align: center;
    }

    h2 {
        color: #333;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    div.active-login {
        background: #FFF;
        border-radius: 8px;
        box-shadow: 1.75px 1.751px 1.751px 0px rgba(0, 0, 0, 0.15);
        margin: 40px auto;
        padding: 20px;
        width: 100%;

        ul {
            background: #F6F6F6;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            margin: 20px 0;
            width: 100%;

            @media (min-width: 1100px) {
                flex-direction: row;
            }

            li {
                align-items: center;
                display: flex;
                flex-direction: column;
                gap: 40px;
                list-style: none;
                justify-content: center;
                padding: 10px 20px;
                width: 100%;

                @media (min-width: 720px) {
                    flex-direction: row;
                    justify-content: space-between;
                    width: 100%;
                }

                @media (min-width: 1100px) {
                    flex-direction: row;
                    justify-content: space-between;
                    width: 50%;
                }

                div.session-info {
                    width: 80%;
                }

                div.session-info > p {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    @media (min-width: 720px) {
                        flex-direction: row;
                    }
                }
            }
        }
    }

    div.status {
        background: #FFF;
        border-radius: 8px;
        box-shadow: 1.75px 1.751px 1.751px 0px rgba(0, 0, 0, 0.15);
        height: fit-content;
        padding: 20px;
        width: 100%;

        @media (min-width: 720px) {
            width: 58%;
        }
        
        @media (min-width: 1100px) {
            width: 30%;
        }

        div > span {
            align-items: center;
            color: #333;
            display: flex;
            font-size: 20px;
            font-style: normal;
            gap: 8px;
            line-height: normal;
            margin: 18px 0;
        }
    }

    div.inputs-container {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        
        @media (min-width: 720px) {
            flex-direction: row;
            flex-wrap: wrap;
            width: 60%;
        }

        div.card {
            background: #FFF;
            border-radius: 8px;
            box-shadow: 1.75px 1.751px 1.751px 0px rgba(0, 0, 0, 0.15);
            margin: 10px 0;
            padding: 10px;
            width: 100%;

            @media (min-width: 1100px) {
                width: 48%;
            }

            h3 {
                align-items: center;
                color: #333;
                display: flex;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                gap: 8px;
                line-height: normal;
            }

            p {
                color: #333;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin: 20px 0;
                text-align: center;
            }
        } 
    } 
    
`;

export const Title = styled.h1`
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 10px 0;
    text-align: center;
    width: 100%;
`;

export const TitleContainer = styled.div`
    width: 100%;
`;

export const Icon = styled(SVG)`
    background: #FFFFFF;
    border: none;
    height: 24px;
    width: 24px;

    @media (min-width: 720px) {
        height: 18px;
        width: 18px;
    }
`;

export const ImageIcon = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: ${({ $isSpecial }) => !$isSpecial ? 'currentColor' : 'none'};
        stroke: ${({ $isSpecial }) => $isSpecial ? 'currentColor' : 'none'};
    }
`;